module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-cyrillic119.ef8acbc.woff2";